import {isCommonValidatorsChanged, updateCommonFields} from "../../dynamic-field/default-control-updater";
import {FieldConfig} from "../../dynamic-field/field.config";
import {ControlUpdater} from "../../dynamic-field/control-updater.type";
import {SlideToggleFieldValidators} from "./slide-toggle.builder";

export const SlideToggleControlUpdater: ControlUpdater = (
    currentFieldConfig: FieldConfig<any>,
    updateFieldConfig: FieldConfig<any>,
    control
) => {
    updateCommonFields(currentFieldConfig, updateFieldConfig, control);

    if (isCommonValidatorsChanged(currentFieldConfig, updateFieldConfig)) {
        const updatedFieldConfig = {...currentFieldConfig, ...updateFieldConfig};

        const validators = SlideToggleFieldValidators(updatedFieldConfig);
        control.setValidators(validators);
        control.updateValueAndValidity({emitEvent: false});
        return;
    }
};
